import { call, put, takeLatest } from "redux-saga/effects"

import {
  CHALLENGE_STATS_USER_TASKS_REQUEST,
  CHALLENGE_STATS_USER_TASKS_ERROR,
  CHALLENGE_STATS_USER_TASKS_SUCCESS,
} from "./constants"

import {
  challengeStatsUserTasksGetApi,
} from "services/api-helpers"

export function* challengeStatsUserTasksRefreshFlow({token, challengeId, userId, callback}) {
  let response
  try {
    response = yield call(challengeStatsUserTasksGetApi, {token, challengeId, userId})
    if("undefined" !== typeof response.httpStatus) {
     yield put({ type: CHALLENGE_STATS_USER_TASKS_ERROR, errors: [{key: "Network error."}] })
    }

    yield put({ type: CHALLENGE_STATS_USER_TASKS_SUCCESS, tasks: response })
    if(typeof callback !== "undefined") {
      yield call(callback)
    }
    
  } catch (error) {
    yield put({ type: CHALLENGE_STATS_USER_TASKS_ERROR, errors: [{key: "Network error."}] })

  }

  return response
}

export default function* ChallengeStatsUserTasksWatcher() {
  yield takeLatest(CHALLENGE_STATS_USER_TASKS_REQUEST, challengeStatsUserTasksRefreshFlow)
}
